import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  useEffect(() => {
    // Load video player script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://scripts.converteai.net/16eda2a6-8c38-45ee-9d2e-9e858106cffa/players/696845bb72fa6d1f6fe52101/v4/player.js';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
    };
  }, []);
  const scrollToNextSection = () => {
    const comparisonSection = document.getElementById('comparison');
    if (comparisonSection) {
      comparisonSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-amber-50 via-stone-50 to-yellow-50 py-12 md:py-16 pb-8 md:pb-12" data-id="element-119">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-120">
        <div className="absolute top-20 left-10 w-40 h-40 md:w-64 md:h-64 bg-amber-300 rounded-full blur-3xl" data-id="element-121"></div>
        <div className="absolute bottom-20 right-10 w-60 h-60 md:w-96 md:h-96 bg-yellow-300 rounded-full blur-3xl" data-id="element-122"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6 text-center" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-124">
          <h1 className="font-serif font-bold mb-3 md:mb-4 leading-tight" data-id="element-125">
            <div className="text-2xl md:text-3xl lg:text-4xl text-stone-800 mb-2" data-id="element-126">
              Método
            </div>
            <div className="text-4xl md:text-6xl lg:text-7xl text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 whitespace-nowrap" data-id="element-127">
              Efeito Boutique
            </div>
          </h1>

          <p className="text-lg md:text-xl text-stone-700 font-light mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-128">
            O segredo que os fornecedores de lembrancinhas escondem das noivas
            para cobrar 10x mais caro - faça você mesma em casa.
          </p>

          {/* Video Player */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="mb-6 md:mb-8 flex justify-center" data-id="element-129">
            <div className="w-full max-w-md" dangerouslySetInnerHTML={{
            __html: '<vturb-smartplayer id="vid-696845bb72fa6d1f6fe52101" style="display: block; margin: 0 auto; width: 100%; max-width: 400px;"></vturb-smartplayer>'
          }} data-id="element-130" />
          </motion.div>

          <motion.button onClick={scrollToNextSection} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="bg-gradient-to-r from-amber-500 to-yellow-600 hover:from-amber-600 hover:to-yellow-700 text-white font-bold text-lg md:text-xl px-10 py-4 md:px-12 md:py-5 rounded-full shadow-2xl transition-all duration-300" data-id="element-131">
            Quero ver como funciona
          </motion.button>

          <p className="text-sm md:text-base text-stone-600 mt-6 md:mt-8" data-id="element-132">
            40 ideias prontas • Passo a passo simples • Economia de até 70%
          </p>
        </motion.div>
      </div>

      {/* Decorative bottom wave */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-133">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-8 md:h-12" preserveAspectRatio="none" data-id="element-134">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#fafaf9" data-id="element-135" />
        </svg>
      </div>
    </section>;
}